import React from 'react';
const VITE_BOOTPAY_ENABLED = (import.meta.env.VITE_BOOTPAY_ENABLED == '1' || import.meta.env.VITE_BOOTPAY_ENABLED == 'true');

interface MemberNavigationProps {
  currentPage?: string;
  hasActiveBillingKey?: boolean;
  showTrustedDevicesLink?: boolean;
}

// NOTE: views/profile/_sublinks.html.erb 의 메뉴와 동일하게 유지할 것

export default function MemberNavigation({
  currentPage = '',
  hasActiveBillingKey = false,
  showTrustedDevicesLink = false,
}: MemberNavigationProps) {
  const navItems = [
    { href: '/my_plan', label: '내 멤버십', key: 'my_plan', enabled: true },
    { href: '/payment/payment_methods', label: '결제수단', key: 'payment', enabled: VITE_BOOTPAY_ENABLED && hasActiveBillingKey },
    { href: '/profile/donations', label: '후원내역', key: 'donations', enabled: true },
    { href: '/profile/my_notes', label: '내 노트', key: 'my_notes', enabled: true },
    { href: '/profile/info', label: '회원정보', key: 'profile', enabled: true },
    { href: '/profile/member_details', label: '상세정보', key: 'member_details', enabled: true },
    { href: '/ask', label: '1:1문의', key: 'inquiry', enabled: true },
    { href: '/users/trusted_devices', label: '신뢰 기기(adm)', key: 'trusted_devices', enabled: showTrustedDevicesLink },
  ];

  return (
    <div className="bg-base-200/50 rounded-lg mb-6">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="text-sm font-medium text-base-content/60">
            회원 메뉴
          </div>
          <div className="flex gap-1 flex-wrap">
            {navItems.filter(item => item.enabled).map((item) => (
              <a
                key={item.key}
                href={item.href}
                className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${currentPage === item.key
                  ? 'bg-primary text-primary-content'
                  : 'text-base-content/70 hover:text-base-content hover:bg-base-300/50'
                  }`}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
